// extracted by mini-css-extract-plugin
module.exports = {"text":"about-module--text--BWg1u","resume":"about-module--resume--23E58","backdrop":"about-module--backdrop--71C4S","img":"about-module--img--3x_JU"};